.itemsContainer {
    display: flex;
    flex-wrap: wrap;
    padding: 0px 20px 0px 0px;
}
.itemContainer {
    display: flex;
    padding: 20px 10px;
}
.textContainer {
    display: flex;
    align-items: center;
    padding: 0px 0px 0px 5px;
}